<template>
  <div v-loading="contentLoading">
    <div class="title">基本信息</div>
    <div style="margin-bottom: 5px">
      <el-button
          type="primary"
          @click="filePreview(esop)">
        预览
      </el-button>
      <el-button
          v-if="downLoadAuth"
          style="margin-left: 5px"
          type="primary"
          :loading="esop.downloadLoading"
          @click="download(esop)">
        下载原文件
      </el-button>
    </div>
    <table cellspacing="0" cellpadding="0" class="EsopTable" style="width: 100%">
      <tr>
        <td class="tableLabel">文件名称</td>
        <td class="tableContent">{{esop.fileName}}</td>
        <td class="tableLabel">格式</td>
        <td class="tableContent">{{esop.fileSuffix}}</td>
      </tr>
      <tr>
        <td class="tableLabel">页码</td>
        <td class="tableContent">{{esop.pdfPageSize}}</td>
        <td class="tableLabel">是否审核</td>
        <td class="tableContent">{{esop.needAuditDesc}}</td>
      </tr>
      <tr>
        <td class="tableLabel">文件状态</td>
        <td class="tableContent">{{esop.statusDesc}}</td>
        <td class="tableLabel">备注</td>
        <td class="tableContent">{{esop.note}}</td>
      </tr>
      <tr>
        <td class="tableLabel">创建人</td>
        <td class="tableContent">{{esop.createName}}</td>
        <td class="tableLabel">创建时间</td>
        <td class="tableContent">{{esop.createTime}}</td>
      </tr>
      <tr>
        <td class="tableLabel">最后更新人</td>
        <td class="tableContent">{{esop.updateName}}</td>
        <td class="tableLabel">最后更新时间</td>
        <td class="tableContent">{{esop.updateTime}}</td>
      </tr>
    </table>
    <template v-if="esop.versionRecords">
      <div class="title">历史版本</div>
      <el-table
          ref="elTable"
          :data="esop.versionRecords.filter(item => item.version < esop.version)"
          border>
        <el-table-column prop="version" label="版本号" align="center" width="70"/>
        <el-table-column prop="fileName" label="文件名称" align="center" show-overflow-tooltip/>
        <el-table-column prop="fileSuffix" label="格式" align="center" width="70"/>
        <el-table-column prop="pdfPageSize" label="页码" align="center" width="70"/>
        <el-table-column prop="createName" label="上传人" align="center" width="110"/>
        <el-table-column prop="createTime" label="上传时间" align="center" width="140"/>
        <el-table-column label="操作" align="center" width="140">
          <template v-slot="scope">
            <el-button
                type="primary"
                @click="filePreview(scope.row)">
              预览
            </el-button>
            <el-button
                v-if="downLoadAuth"
                style="margin-left: 5px"
                type="primary"
                :loading="esop.downloadLoading"
                @click="download(scope.row)">
              下载原文件
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template v-if="esop.esopMaterials && esop.esopMaterials.length > 0">
      <div class="title">关联物料</div>
      <el-table
          :data="esop.esopMaterials"
          border>
        <el-table-column type="index" label="序号" align="center" width="40"/>
        <el-table-column prop="materialNo" label="物料号" align="center" width="120"/>
        <el-table-column prop="materialName" label="物料描述" show-overflow-tooltip/>
        <el-table-column prop="createName" label="绑定人" align="center" width="110"/>
        <el-table-column prop="createTime" label="绑定时间" align="center" width="140"/>
      </el-table>
    </template>
    <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId"/>
    <pdf-reader ref="pdfReader"/>
  </div>
</template>

<script>

  import HandleDetail from "@/views/workFlow/HandleDetail.vue";
  import PdfReader from "@/views/information/Esop/PdfReader.vue";

  export default {
    name: "EsopWorkFlow",
    components: {PdfReader, HandleDetail},
    props: {
      esopId: {
        type: Number,
        required: true,
      },
      billId: {
        type: String,
        required: true,
      },
      billType: {
        type: String,
        required: true,
      },
      sequId: {
        type: String,
        required: true,
      },
      params: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        contentLoading: false,
        downLoadAuth: this.$auth(340),//同preview下载
        esop: {
          id: "",
          fileType: "",
          version: "",
          originFileName: "",
          fileName: "",
          filePath: "",
          pdfFilePath: "",
          pdfPageSize: "",
          needAudit: "",
          needAuditDesc: "",
          status: "",
          statusDesc: "",
          auditStatus: "",
          note: "",
          versionRecordId: "",
          versionRecords: [],
          esopMaterials: [],
        },
      };
    },
    watch: {
      params: {
        handler() {
          this.handleSubmit();
        },
      },
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `esops/detail/${this.esopId}`)
          .then(res => {
            this.esop = res;
          })
          .finally(() => {
            this.contentLoading = false;
          });
      },
      download(row) {
        this.$set(row, "downloadLoading", true);
        let data = {
          name: row.fullFileName,
          uuid: row.filePath,
        };
        this.$http
          .exportFile("basic", "file/download", data)
          .then((res) => {
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.config.params.name);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
          }).catch(() => {
            this.$message.error("下载失败");
          })
          .finally(() => {
            row.downloadLoading = false;
          });
      },
      filePreview(row) {
        let url = `file/download?uuid=${row.pdfFilePath}&name=${row.fileName}.pdf`;
        this.$refs.pdfReader.open(url);
      },
      handleSubmit() {
        let approveVar = "";
        if (this.params.actionType === 0) {
          let list = this.params.applicationVarVOS;
          if (list.length > 0) {
            for (let i = 0; i < list.length; i++) {
              if (i === list.length - 1) {
                approveVar += list[i].varName + "#" + list[i].varValue;
              } else {
                approveVar += list[i].varName + "#" + list[i].varValue + "|";
              }
            }
          }
        }
        this.esop.approveDataSvo = {
          billId: parseInt(this.billId),
          billType: parseInt(this.billType),
          sequId: parseInt(this.sequId),
          actionType: this.params.actionType,
          approveNote: this.params.approveNote,
          untreadedFlowId: this.params.untreadedFlowId,
          transferTo: this.params.transferTo,
          approveVar: approveVar,
        };
        this.submitLoading = true;
        this.$http.post("basic", "esops/workflow/submit", this.esop).then(() => {
          this.$message.success("操作成功");
          // 关闭标签
          this.$bus.$emit("closeTag", this.$route);
          this.$router.push({
            path: "/workFlow/EsopUnhandled",
          });
        }).finally(() => {
          this.submitLoading = false;
        });
      },
    },
  };
</script>

<style scoped lang="scss">
.EsopTable {
  font-family: verdana, arial, sans-serif;
  font-size: 13px;
  color: #333333;
  border-left: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
}
.EsopTable td {
  padding: 5px;
  border-right: 1px solid #dddddd;
  border-top: 1px solid #dddddd;
}
.title {
  font-size:16px;
  border-bottom:1px solid #ccc;
  width:100%;
  margin:10px 0 5px;
}
.tableLabel {
  width: 20%;
  text-align: right;
  background-color: #D1E6F5;
}
.tableContent {
  width: 30%;
  text-align: left;
  white-space: pre-wrap;
}
</style>
